import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Col, Row } from 'reactstrap';
import Pagination from 'rc-pagination';
import { getAllProcessedFaxes } from '../../actions/Fax';

import SetLimitEntries from '../../components/SetLimitEntries';
import { ENG_LOCALE } from '../../lib/constants';
import utils from '../../lib/utils';
const INITIAL_PAGE_STATE = {
  nextPage: null,
  hasNextPage: null,
  hasPrevPage: null,
  limit: null,
  page: null,
  pagingCounter: null,
  prevPage: null,
  totalDocs: null,
  totalPages: null,
};
export default function ({ filterValues = {} }) {
  const token = localStorage.getItem('jwtToken') || null;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [pageData, setPageData] = useState(INITIAL_PAGE_STATE);
  const dispatch = useDispatch();
  useEffect(() => {
    getData({ page: 1, limit: 10 });
  }, [filterValues]);

  const getData = utils.debounce(async ({ limit, page }) => {
    const { from, to } = filterValues;
    const fromDate = from ? moment(from).format('YYYY-MM-DDT23:59:59.999Z') : '';
    const toDate = to ? moment(to).format('YYYY-MM-DDT23:59:59.999Z') : '';
    const updatedFilter = { ...filterValues, from: fromDate, to: toDate };

    const data = await dispatch(
      getAllProcessedFaxes(token, {
        ...updatedFilter,
        paginateOptions: JSON.stringify({
          limit: limit ? limit : pageData.limit,
          page: page ? page : pageData.page,
        }),
      }),
    );

    if (data?.docs) {
      const {
        nextPage,
        hasNextPage,
        hasPrevPage,
        limit,
        page,
        pagingCounter,
        prevPage,
        totalDocs,
        totalPages,
        docs,
      } = data;
      setPageData({
        nextPage,
        hasNextPage,
        hasPrevPage,
        limit,
        page,
        pagingCounter,
        prevPage,
        totalDocs,
        totalPages,
      });
      setData([...docs]);
      setLoading(false);
    } else {
      setData([]);
      setPageData(INITIAL_PAGE_STATE);
    }
  }, 600);
  return (
    <div>
      <div className="table-header-fixed">
        <table>
          <thead>
            <tr>
              <th className="cursor-pointer">Date</th>
              <th className="cursor-pointer">Sender Company</th>
              <th className="cursor-pointer">Receiver Company</th>
              <th className="cursor-pointer">Sender Edge Device Serial #</th>
              <th className="cursor-pointer">Receiver Edge Device Serial #</th>
              <th className="cursor-pointer">Sender #</th>
              <th className="cursor-pointer">Receiver #</th>
              <th className="cursor-pointer">Description</th>
              <th className="cursor-pointer">Status</th>
            </tr>
          </thead>
          <tbody>
            {data.length ? (
              data.map(fax => (
                <tr key={fax._id}>
                  <td>{utils.getDateTimeFormat(fax.date, 'both')}</td>
                  <td>{fax.senderCompany}</td>
                  <td>{fax.receiverCompany}</td>
                  <td>{fax.senderBox}</td>
                  <td>{fax.receiverBox}</td>
                  <td>{fax.sender}</td>
                  <td>{fax.receiver}</td>
                  <td>{fax.description}</td>
                  <td>{fax.status}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={12}>
                  <Alert rowSpan={12} color="info">
                    {loading ? 'Loading...' : 'No Faxes Found'}
                  </Alert>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {!!data.length && (
        <Row className="justify-content-md-center">
          <SetLimitEntries value={pageData.limit} onChange={limit => getData({ limit })} />
          <Pagination
            locale={ENG_LOCALE}
            className="pagination-container"
            onChange={page => getData({ page })}
            current={pageData.page}
            total={pageData.totalDocs}
            pageSize={pageData.limit}
            showLessItems
            showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
          />
        </Row>
      )}
    </div>
  );
}
